import React, { FC, useMemo } from "react";
import { View } from "react-native";
import Animated, { useAnimatedStyle, withTiming } from "react-native-reanimated";
import { ButtonIcon } from "@lookiero/sty-psp-ui";
import { style as basketIconStyle } from "./BasketIcon.style";

interface BasketIconProps {
  readonly notification?: boolean;
  readonly testID?: string;
  readonly onPress: () => void;
}

const BasketIcon: FC<BasketIconProps> = ({ notification, testID = "basket-button", onPress }) => {
  const style = useMemo(() => basketIconStyle(), []);

  const badgeAnimatedStyle = useAnimatedStyle(
    () => ({
      opacity: withTiming(notification ? 1 : 0),
      scale: withTiming(notification ? 1 : 0),
    }),
    [notification],
  );

  return (
    <View>
      <ButtonIcon name="basket" testID={testID} onPress={onPress} />
      <Animated.View style={[style.badge, badgeAnimatedStyle]} />
    </View>
  );
};

export { BasketIcon };
